import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Page } from '../types/page';
import {
  BulkCancelPricingOfferDto,
  BulkCreatePricingOfferDto,
  ClientPricingOffer,
  ClientPricingOfferDto,
} from '../types/client-pricing-offer';
import { SearchOptionsDTO } from '../types/search-options';
import { AccrualCode } from '../types/accrual';

@Injectable()
export class ClientPricingOfferService {
  public civilIdsForBulkCancel$ = new BehaviorSubject<string[]>([]);

  constructor(private request: RequestService) { }

  getClientPricingOfferList$(options?: SearchOptionsDTO): Observable<Page<ClientPricingOffer>> {
    return this.request.get(['client-pricing-offers'], { params: options });
  }

  getClientPricingOfferById$(id: number): Observable<ClientPricingOffer> {
    return this.request.get(['client-pricing-offers', id]);
  }

  getClientPricingAccrualTypes$(): Observable<AccrualCode[]> {
    return this.request.get(['client-pricing-offers', 'accrual-types']);
  }

  getActiveOffersByCreditId(creditId: number): Observable<ClientPricingOffer[]> {
     return this.request.get(['client-pricing-offers', 'credits', creditId]);
  }

  createClientPricingOffer$(
    offer: ClientPricingOfferDto,
  ): Observable<ClientPricingOffer> {
    ;
    return this.request.post(['client-pricing-offers'], {
      body: offer
    });
  }

  cancelClientPricingOffer$(
    id: number,
  ): Observable<ClientPricingOffer> {
    return this.request.post(['client-pricing-offers', id, 'cancel']);
  }

  createBulkClientPricingOffers$(
    bulkRequest: BulkCreatePricingOfferDto,
  ): Observable<{ success: ClientPricingOffer[], errors: any[] }> {
    return this.request.post(['client-pricing-offers', 'bulk'], {
      body: bulkRequest
    });
  }

  bulkCancelClientPricingOffers$(
    bulkCancelRequest: BulkCancelPricingOfferDto,
  ): Observable<{ success: ClientPricingOffer[], errors: any[] }> {
    return this.request.post(['client-pricing-offers', 'bulk-cancel'], {
      body: bulkCancelRequest
    });
  }
}